module.exports = __webpack_public_path__ + "img/招贤纳士.b5f0073f.jpg";